export default __webpack_public_path__ + "static/media/facebook-logo.5f67a13e.svg";